import Cookies from 'js-cookie';
import { TENANT_STORAGE_KEY } from '@constants/tenant';

const globalFeatures = new Set(
  (process.env.NEXT_PUBLIC_ENABLED_FEATURES || '').split(',').filter(Boolean)
);

const tenantFeaturesMap: Record<string, string[]> = ((): Record<string, string[]> => {
  try { return JSON.parse(process.env.NEXT_PUBLIC_TENANT_FEATURES || '{}'); } catch { return {}; }
})();

const getCurrentTenantKey = (): string | null => {
  try { return JSON.parse(Cookies.get(TENANT_STORAGE_KEY) || 'null')?.key ?? null; } catch { return null; }
};

export const FEATURES = {
  GOOGLE_SHOPPING_AGENT: 'google-shopping-agent',
  CX_AGENT_STUDIO: 'cx-agent-studio',
  CCAI_WIDGET: 'ccai-widget',
  DYNAMIC_UI: 'dynamic-ui',
  AR_PREVIEW: 'ar-preview',
  RCS: 'rcs',
  UCP: 'ucp',
  SMART_SEARCH: 'smart-search',
  PLACEMENT: 'placement',
  MULTI_TENANCY: 'multi-tenancy',
  MANAGE_TENANTS: 'manage-tenants',
  GECX_SIDEBAR: 'gecx-sidebar',
} as const;

export const isFeatureEnabled = (feature: string, tenantKey?: string | null): boolean => {
  if (globalFeatures.has(feature)) return true;
  const key = tenantKey !== undefined ? tenantKey : getCurrentTenantKey();
  if (key) return (tenantFeaturesMap[key] || []).includes(feature);

  return false;
};
